module.exports = __webpack_public_path__ + "static/media/register-1440w.e0a5982d.jpg";